import React from "react";
import { CustomCardWithCharts } from "../../../../SharedComponents/CustomCardWithCharts";
import { groupBy } from "../../../../Utils/js-common";
import { CUSTOMER_VIEW_STYLES } from "../../../CustomerView/CustomerView.styles";

const COSOCChart = (props: {
  loading: boolean;
  onSelectedChartFilter: React.Dispatch<
    React.SetStateAction<{
      filterKey: string;
      value: string;
    }>
  >;
  tenantId: any;
  tenantName: any;
  filteredData: any;
  originalData: any;
}) => {
  // Properties
  const [metricFilters, setMetricFilters] = React.useState<{ [key: string]: any }>({});

  // Events
  const handleResetFilters = () => {
    setMetricFilters({});
    props.onSelectedChartFilter({
      filterKey: "",
      value: ""
    });
  };

  // Events
  const getGroupedData = (key: string, data: any[]) => {
    const arr = Array.isArray(data) ? data : [];
    const filteredData = arr.filter((item) => item && item[key]);
    const groupedData = groupBy(filteredData, key);

    return Object.keys(groupedData)?.map((item) => ({
      name: item,
      value: groupedData[item].length
    }));
  };
  /**
   * onClick action for each datapoint in the chart
   */
  const handleDataPointClick = (option: any) => {
    // Use option.field, option.title, option.value if available
    props.onSelectedChartFilter({
      filterKey: option.field,
      value: option.value
    });
    setMetricFilters((prev) => ({ ...prev, [option.title]: option.value }));
  };
  const groupByDate = groupBy(props.filteredData, "endOfMonth");
  const dataByMonthYear = Object.keys(groupByDate)
    .map((item) => {
      const date = new Date(new Date(item).toISOString());
      if (isNaN(date.getTime())) return null; // Skip invalid dates
      return {
        x: date,
        y: groupByDate[item]?.length ?? 0 // Ensure y is always a number
      };
    })
    .filter((point): point is { x: Date; y: number } => point !== null); // TypeScript type guard
  // Sort by X-axis date
  dataByMonthYear.sort((a, b) => a.x.getTime() - b.x.getTime());

  const stackOverflowSourceDistribution = getGroupedData("stackOverflowSource", props.filteredData);
  const endOfMonthDistribution = getGroupedData("endOfMonth", props.filteredData);

  return (
    <>
      <div className={CUSTOMER_VIEW_STYLES.COMMON_STYLES.CLASS_NAMES.customCardContainer}>
      <CustomCardWithCharts
        loading={props.loading}
        metricFilters={metricFilters}
        onDataPointClick={handleDataPointClick}
        onResetFilters={handleResetFilters}
        options={{
          filteredData: props.filteredData,
          chartOptions: [
            {
              id: 1,
              field: "stackOverflowSource",
              key: "customer-view-customer-cosoc-chart-by-source",
              title: "Community Volume by Channel",
              type: "donut",
              groupedData: stackOverflowSourceDistribution,
              kustoLink: props.originalData?.cosocVolumeByChannel
            },
            {
              id: 2,
              field: "endOfMonth",
              key: "customer-view-customer-cosoc-chart-by-endOfMonth",
              title: "Community Volume Trend",
              type: "line",
              groupedData: endOfMonthDistribution,
              legendName: "Community Volume",
              xaxisTitle: "Question Date",
              yaxisTitle: "Number of Questions",
              kustoLink: props.originalData?.cosocVolumeTrend
            },
            {
              id: 3,
              field: "endOfMonth",
              key: "customer-view-customer-cosoc-chart-by-kpi-trend-endOfMonth",
              title: "Community KPI Trend",
              type: "multiline",
              seriesConfig:[
                {
                  legend: "SLA Met",
                  filterKey: "slaMet",
                  filterValue: "1",
                  color: "#0078D4"
                },
                {
                  legend: "Questions Answered",
                  filterKey: "verifiedAnswer",
                  filterValue: 1,
                  color: "#00B294"
                },
                {
                  legend: "Verified Answer",
                  filterKey: "questionsAnswered",
                  filterValue: 1,
                  color: "rgb(227, 0, 140)"
                }
              ],
              groupedData: endOfMonthDistribution,
              xaxisTitle: "Question Date",
              yaxisTitle: "Count",
              kustoLink: props.originalData?.cosocVolumeKPITrend
            }
          ]
        }}
      />
      </div>
    </>
  );
};

export default COSOCChart;
